import { isAzureAuthoredFailure } from "./isAzureAuthoredFailure";
import type { ConnectionCheckResult, DocumentLoadFailure } from "./types";

export type DocumentFailureOrigin = "azure-authored" | "network-blocked" | "unknown";

const networkErrorMessage = /failed to fetch|networkerror|load failed/i;

// Only known browser network messages count — a bare TypeError can come from viewer code too.
const isNetworkLevelFailure = (failure: DocumentLoadFailure): boolean =>
  failure.statusCode === undefined && networkErrorMessage.test(failure.errorMessage);

export const isUsableLoadFailure = (failure: DocumentLoadFailure): boolean =>
  failure.statusCode !== undefined || failure.errorName === "MissingPDFException" || isNetworkLevelFailure(failure);

export const judgeDocumentFailure = (
  loadFailure: DocumentLoadFailure | undefined,
  documentCheck: ConnectionCheckResult | undefined
): DocumentFailureOrigin => {
  const failedCheck = documentCheck && !documentCheck.ok ? documentCheck : undefined;
  if (failedCheck && isAzureAuthoredFailure(failedCheck.failureDetails)) {
    return "azure-authored";
  }
  // A cross-origin status is only readable when the response carried Azure's CORS headers.
  if (loadFailure?.statusCode !== undefined || loadFailure?.errorName === "MissingPDFException") {
    return "azure-authored";
  }
  if (loadFailure && isNetworkLevelFailure(loadFailure)) {
    return "network-blocked";
  }
  if (failedCheck?.failureDetails) {
    return "network-blocked";
  }
  return "unknown";
};
